/* eslint-disable */
module.exports = {
  request: function (req, token) {
    this.options.http._setHeaders.call(this, req, {Authorization: token})
  },
  response: function (res) {
    if (res.status == 200) {
      let headers = this.options.http._getHeaders.call(this, res)
      let authorization = headers.Authorization || headers.authorization
      if (authorization) {
        return authorization
      }
    } else if (res.status == 403) {
      window.localStorage.removeItem('default_auth_token')
      window.location = '/login'
    }
  }
}
